import React, {useState, useEffect} from 'react'
import ReactMapGL, {Marker, FlyToInterpolator,LinearInterpolator, WebMercatorViewport} from 'react-map-gl';
// import {easeCubic} from 'd3-ease';
//import useSize from '@react-hook/size'
import mapboxgl from 'mapbox-gl';
import useWindowDimensions from './useWindowDimensions'
import markerOne from '../images/Icon-one.svg'
import markerTwo from '../images/Icon-two.svg'
import markerThree from '../images/Icon-three.svg'
import 'mapbox-gl/dist/mapbox-gl.css'

// The following is required to stop "npm build" from transpiling mapbox code.
// notice the exclamation point in the import.
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;


const MapMultiple = ({showPage, packingData, harvestData, hiveData, goToPage}) => {


  // maxin and minin
  const minHiveLat = Math.min(...hiveData.hiveLat)
  const maxHiveLat = Math.max(...hiveData.hiveLat)
  const minHiveLong = Math.min(...hiveData.hiveLong)
  const maxHiveLong = Math.max(...hiveData.hiveLong)


  const minHarvestLat = Math.min(...harvestData.harvestLat)
  const maxHarvestLat = Math.max(...harvestData.harvestLat)
  const minHarvestLong = Math.min(...harvestData.harvestLong)
  const maxHarvestLong = Math.max(...harvestData.harvestLong)

  // combine arrays of all latitudes
  let allLat = hiveData.hiveLat.concat(harvestData.harvestLat)
  allLat.push(packingData.lat)

  // combine arrays of all longitudes
  let allLong = hiveData.hiveLong.concat(harvestData.harvestLong)
  allLong.push(packingData.lng)
  
  //max / min them
  const minLat = Math.min(...allLat)
  const maxLat = Math.max(...allLat)
  const minLong = Math.min(...allLong)
  const maxLong = Math.max(...allLong)

  // get browser height, width with useWindowDimension hook
  const { height, width } = useWindowDimensions()
  // set up map height and width depending on screen size (note: 100%, 100vh not working for fitBounds)
  const browserHeight = (width > 1024) ? height : 400
  const browserWidth = (width > 1024) ? (width - 480) : width
  
  const [viewport, setViewport] = useState({
    width: browserWidth,
    height: browserHeight,
    latitude: 39.10330725755949,
    longitude: -94.59497958948299,
    pitch: 0,
    zoom: 4
  });
  const[test, setTest] = useState(false)
  const[test2, setTest2] = useState(false)

useEffect(()=> {
  if(showPage===1) {
    goTo1()
  }
  if(showPage===2){
   goTo2()
  }
  if(showPage===3){
    goTo3()
  }
  if(showPage===4){
    goTo4()
  }

}, [showPage])


  // Step 1 animation
  const goTo1 = () => {

    // check if more than one hive locations
    if(hiveData.hiveLat.length > 1) {
      const timer = setTimeout(() => {
        console.log('all lat vals' + hiveData.hiveLat)
        const {longitude, latitude, zoom} = new WebMercatorViewport(viewport)
          .fitBounds([[minHiveLong, minHiveLat], [maxHiveLong, maxHiveLat]], {
            padding: 60,
            offset: [0, -100]
          });
        setViewport({
          ...viewport,
          longitude,
          latitude,
          zoom,
          transitionDuration: 1000,
          transitionInterpolator: new FlyToInterpolator(),
          // transitionEasing: d3.easeCubic
        });
      }, 1000);
     return () => clearTimeout(timer);
    } else {
    
      // show single version if only one
      const timer = setTimeout(() => {
        setViewport({
            ...viewport,
            longitude: hiveData.hiveLong[0],
            latitude: hiveData.hiveLat[0],
            transitionDuration: 1600,
            transitionInterpolator: new LinearInterpolator(),
            zoom: 10,
    
        //   transitionEasing: easeCubic(0.25)
        });
      }, 1000);
      return () => clearTimeout(timer);
    }
  }

  //Step 2 animation
  const goTo2 = () => {
    console.log(harvestData.harvestLat)
    if(harvestData.harvestLat.length > 1) {
      const {longitude, latitude, zoom} = new WebMercatorViewport(viewport)
      .fitBounds([[minHarvestLong, minHarvestLat], [maxHarvestLong, maxHarvestLat]], {
        padding: 60,
        offset: [0, -100]
      });
      setViewport({
        ...viewport,
        longitude,
        latitude,
        zoom,
        transitionDuration: 800,
        transitionInterpolator: new FlyToInterpolator(),
      //   transitionEasing: easeCubic(0.25)
      });
      setTest(true)
    } else {
      // console.log('single harvest')
      // console.log(minHarvestLat)
      // console.log(minHarvestLong)
      setViewport({
        ...viewport,
        longitude: harvestData.harvestLong[0],
        latitude: harvestData.harvestLat[0],
        zoom: 10,
        transitionDuration: 800,
        transitionInterpolator: new FlyToInterpolator(),
      //   transitionEasing: easeCubic(0.25)
      });
    }
 

    setTest(true)
  
  };

  //Step 3 animation

  const goTo3 = () => {
      setViewport({
        ...viewport,
        longitude: packingData.lng,
        latitude: packingData.lat,
        zoom: 10,
        transitionDuration: 800,
        transitionInterpolator: new FlyToInterpolator(),
      //   transitionEasing: easeCubic(0.25)
      });
      setTest(true)
      setTest2(true)
      
 
  };

  // Final screen
  const goTo4 = () => {
    const {longitude, latitude, zoom} = new WebMercatorViewport(viewport)
        .fitBounds([[minLong, minLat], [maxLong, maxLat]], {
          padding: 80,
          offset: [0, -100]
        });
    setViewport({
      ...viewport,
      longitude,
      latitude,
      zoom,
      transitionDuration: 1000,
      transitionInterpolator: new FlyToInterpolator(),
      // transitionEasing: d3.easeCubic
    });
    setTest(true)
    setTest2(true)
  };
  return (
    <div>
        <ReactMapGL
        mapboxApiAccessToken={
          "pk.eyJ1IjoiYWdlbnRicmFuZGluZyIsImEiOiJjanlyZDYyenMwOXdxM29taTVnems1enQ3In0.b6-a6FjoAmqH24hBllOC9A"
        }
        {...viewport}
         mapStyle={"mapbox://styles/agentbranding/cku8g5x9t0ljw19s01ig5bhsq"}
        onViewportChange={nextViewport => setViewport(nextViewport)}
        scrollZoom={true}
        dragPan={true}
        dragRotate={false}
        touchZoom={true}
        doubleClickZoom={false}
        
        >
            {
              //hive markers
              hiveData.hiveCoords.map((hive, i) => {
                return (
                  <Marker key={i} longitude={hive.long} offsetLeft={0} offsetTop={0} latitude={hive.lat}>
                    <div className="bb-marker"><img src={markerOne} alt="Hive Location Marker" /></div>
                  </Marker>
                )           
              })
            }
            
            {
            // harvest markers
            harvestData.harvestCoords.map((harvest, i) => {
              return ( 
                test &&
                <Marker  key={i} longitude={harvest.long} offsetLeft={-20} offsetTop={0} latitude={harvest.lat}>
                  <div className="bb-marker"><img src={markerTwo} alt="Harvest Location Marker" /></div>
                </Marker>
                
              )           
            })
            }
            

            {test2 && <Marker key="3" longitude={packingData.lng} offsetLeft={0} offsetTop={0} latitude={packingData.lat}>
                <div className="bb-marker"><img src={markerThree} alt="Packing Location Marker" /></div>
            </Marker> }
            
        </ReactMapGL>
    </div>
  );
}

export default MapMultiple


